import R from "ramda";
import { http } from "./http";

export const fetchAccountSettings = (accountId) => (
  http.get(`/accounts/${accountId}/settings`)
    .then((response) => {
      const accountSettings = response.data;
      accountSettings.vat = parseFloat(accountSettings.vat);
      return { accountSettings };
    })
);

export const fetchAccountDetails = (accountId) => (
  http.get(`/accounts/${accountId}?include_usage=true`)
    .then(response => {
      const accountDetails = response.data;
      const planDetails = R.path(["data", "plan"], response);
      return { accountDetails, planDetails };
    })
);

export const fetchPlans = (accountId) => (
  http.get(`accounts/${accountId}/plans`)
    .then(response => {
      const plans = R.path(["data", "plans"], response);
      return { plans };
    })
);

export const putAccountSettings = (accountId, settings) => (
  http.put(`/accounts/${accountId}`, settings)
);

export const fetchLocales = (accountId) => (
  http.get(`/accounts/${accountId}/locales`)
    .then(response => {
      const supportedLocales = R.path(["data", "supported"], response);
      return { supportedLocales, response };
    })
);

export const putCurrencyLocaleTax = (accountId, settings) => (
  http.put(`/accounts/${accountId}/settings`, settings)
);

export const putNewPlan = (accountId, plan) => (
  http.put(`accounts/${accountId}/plan`, plan)
);

export const fetchBillingHistory = (accountId) => (
  http.get(`accounts/${accountId}/billing/invoices`)
    .then(response => {
      const invoices = R.path(["data", "invoices"], response);
      return { invoices };
    })
);

export const fetchBillingDetails = (accountId) => (
  http.get(`accounts/${accountId}/billing-info`)
    .then(response => {
      const billingDetails = response.data;
      return { billingDetails };
    })
);

export const fetchAccountUsers = (accountId) => (
  http.get(`/accounts/${accountId}/users`)
    .then((response) => {
      const maxUsers = R.path(["data", "maxUsers"], response);
      const users = R.path(["data", "users"], response);
      return { maxUsers, users };
    })
);

export const deleteUser = (accountId, userId) => http.delete(`accounts/${accountId}/users/${userId}`);

export const createUser = (accountId, user) => (
  http.post(`accounts/${accountId}/users`, user)
    .then((response) => {
      const newUser = response.data;
      return { newUser };
    })
);

export const postBillingDetails = () => {
  // eslint-disable-next-line no-console
  console.warn("This is a stub");
  return Promise.resolve({
    expiryMonth: "2",
    expiryYear: "2020",
    lastFourDigits: "1111",
    name: "Test",
    surname: "Test"
  });
};

export const putDocReturn = (accountId, isOn) => (
  http.put(`accounts/${accountId}/settings`, { docReturn: isOn })
);

export const fetchPendingPlan = (accountId) => (
  http.get(`accounts/${accountId}/plan`)
    .then(response => {
      const cancelDate = R.pathOr(null, ["data", "expired"], response);
      const pendingPlan = R.pathOr(null, ["data", "pendingPlan"], response);
      return { cancelDate, pendingPlan };
    })
);

export const billingRedirect = (accountId) => {
  const data = {
    account_id: accountId,
    redirect_uri: `${OLD_UI_BASE_URL}/member/v2/settings#billing_history`
  };
  return http.nonAjaxPost(`${OLD_UI_BASE_URL}/member/set-account.htm`, data);
};



// WEBPACK FOOTER //
// ./src/js/api/account-settings.js